import axios from 'axios'
import type { ApiResponse } from '@/types'

// 创建axios实例
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 添加认证token
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // 每30分钟刷新一次token
    const token = localStorage.getItem('access_token')
    const lastRefreshTime = localStorage.getItem('last_token_refresh_time')
    const now = Date.now()
    const thirtyMinutes = 30 * 60 * 1000 // 30分钟的毫秒数

    if (token && (!lastRefreshTime || now - Number(lastRefreshTime) > thirtyMinutes)) {
      api.post('/auth/refresh')
        .then(res => {
          if (res.data?.access_token) {
            localStorage.setItem('access_token', res.data.access_token)
            localStorage.setItem('last_token_refresh_time', String(now))
          }
        })
        .catch(console.error)
    }
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // 清除本地token
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      localStorage.removeItem('last_token_refresh_time')
      // 重定向到登录页面
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api

// 通用API方法
export const apiGet = <T>(url: string, params?: any): Promise<ApiResponse<T>> => {
  return api.get(url, { params }).then(res => res.data)
}

export const apiPost = <T>(url: string, data?: any): Promise<ApiResponse<T>> => {
  return api.post(url, data).then(res => res.data)
}

export const apiPut = <T>(url: string, data?: any): Promise<ApiResponse<T>> => {
  return api.put(url, data).then(res => res.data)
}

export const apiDelete = <T>(url: string): Promise<ApiResponse<T>> => {
  return api.delete(url).then(res => res.data)
}